import * as Yup from 'yup';

export const signupValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be less than 50 characters')
    .matches(/^[a-zA-Z\s]*$/, 'First name can only contain letters and spaces')
    .required('First name is required'),

  lastName: Yup.string()
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be less than 50 characters')
    .matches(/^[a-zA-Z\s]*$/, 'Last name can only contain letters and spaces')
    .required('Last name is required'),

  email: Yup.string()
    .email('Please enter a valid email address')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Please enter a valid email address with a proper domain')
    .required('Email is required'),

  businessName: Yup.string()
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be less than 100 characters')
    .required('Business name is required'),

  portalUrl: Yup.string()
    .min(3, 'Portal URL must be at least 3 characters')
    .max(50, 'Portal URL must be less than 50 characters')
    .matches(
      /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
      'Portal URL can only contain letters, numbers, and hyphens. Cannot start or end with a hyphen.',
    )
    .required('Portal URL is required'),

  agreeToTerms: Yup.boolean()
    .oneOf([true], 'You must agree to the terms and conditions')
    .required('You must agree to the terms and conditions'),
});
